import { createTheme } from '@targetx/mineral-ui/themes';

export default createTheme({
  overrides: {}
});
